import { render, staticRenderFns } from "./customimport.vue?vue&type=template&id=00822a2e"
import script from "./customimport.vue?vue&type=script&lang=js"
export * from "./customimport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports